import { Country, CountryList } from '../../models/country';

export const parseDate = (date: Date, end: boolean = false) => {
  // console.log('date', date);
  const newDate = new Date(date);
  // console.log('newDate', newDate);
  //  newDate.setDate(newDate.getDate() + 1);
  // console.log('newDate after setDate', newDate);

  const year = newDate.getFullYear();
  const month = String(newDate.getMonth() + 1).padStart(2, '0');
  const day = String(newDate.getDate()).padStart(2, '0');
  const time = end ? '23:59:59' : '00:00:00';

  return `${year}-${month}-${day}T${time}`;
};

export const clearFilterToSend = (filter: any, type?: string) => {
  if (!filter) return {};
  const filterToSend: any = {};
  if (filter.id && filter.id.length > 0) {
    switch (type) {
      case 'companies':
        filterToSend.id = filter.id;
        break;
      case 'issues':
      case 'validations':
      case 'time-insights':
        filterToSend['insight.id'] = filter.id;
        break;
      case 'insights':
        filterToSend['requestMessages.id'] = filter.id;
        break;
      default:
        filterToSend.id = { inq: [...filter.id] };
        break;
    }
  }
  if (filter.name) {
    switch (type) {
      case 'issues':
        filterToSend.or = [
          { 'issues.name': { ilike: encodeURIComponent(`%${filter.name}%`) } },
          { 'issues.reason': { ilike: encodeURIComponent(`%${filter.name}%`) } },
        ];
        break;
      case 'validations':
        filterToSend.or = [
          { 'values.name': { ilike: encodeURIComponent(`%${filter.name}%`) } },
          { 'values.reason': { ilike: encodeURIComponent(`%${filter.name}%`) } },
        ];
        break;

      case 'time-insights':
        filterToSend.or = [
          { 'insight.name': { ilike: encodeURIComponent(`%${filter.name}%`) } },
          { 'insight.summary': { ilike: encodeURIComponent(`%${filter.name}%`) } },
          { 'insight.id': { ilike: encodeURIComponent(`%${filter.name}%`) } },
        ];
        break;
      case 'insights':
      case 'request':
        filterToSend['requestMessages.name'] = { ilike: encodeURIComponent(`%${filter.name}%`) };
        break;
      case 'feedback':
        filterToSend.or = [
          { name: { ilike: encodeURIComponent(`%${filter.name}%`) } },
          { summary: { ilike: encodeURIComponent(`%${filter.name}%`) } },
          { id: { ilike: encodeURIComponent(`%${filter.name}%`) } },
        ];
        break;
      case 'topics-feedback':
        filterToSend.or = [
          { name: { ilike: `%${filter.name}%` } },
          { summary: { ilike: `%${filter.name}%` } },
          // { id: { ilike: encodeURIComponent(`%${filter.name}%`) } },
        ];
        break;
      case 'topics-validations':
        filterToSend.or = [
          { values_name: { ilike: `%${filter.name}%` } },
          { values_reason: { ilike: `%${filter.name}%` } },
          { values_extracts: { ilike: `%${filter.name}%` } },
        ];
        break;
      case 'topics-issues':
        filterToSend.or = [
          { issues_name: { ilike: `%${filter.name}%` } },
          { issues_reason: { ilike: `%${filter.name}%` } },
          { issues_extracts: { ilike: `%${filter.name}%` } },
        ];
        break;
      case 'profiles':
        filterToSend.or = [
          { 'profile.name': { ilike: encodeURIComponent(`%${filter.name}%`) } },
          { 'profile.email': { ilike: encodeURIComponent(`%${filter.name}%`) } },
        ];
        break;
      case 'sessions':
        filterToSend.or = [
          { 'crmContact.name': { ilike: encodeURIComponent(`%${filter.name}%`) } },
          { 'crmContact.email': { ilike: encodeURIComponent(`%${filter.name}%`) } },
        ];
        break;
      case 'crm':
        filterToSend.or = [
          { name: { ilike: encodeURIComponent(`%${filter.name}%`) } },
          { lastname: { ilike: encodeURIComponent(`%${filter.name}%`) } },
        ];
        break;
      default:
        filterToSend.name = { ilike: encodeURIComponent(`%${filter.name}%`) };
        break;
    }
  }
  if (filter.email?.length > 0) {
    switch (type) {
      case 'profiles':
        filterToSend['profile.email'] = filter.email;
        break;
      default:
        filterToSend.email = filter.email;
        break;
    }
  }
  if (filter.city) {
    filterToSend.city = { inq: filter.city.map((city: any) => city?.id) };
  }
  if (filter.country) {
    filterToSend.country = { inq: [CountryList[filter.country.toUpperCase() as Country]] };
  }
  if (filter.status?.length > 0) {
    switch (type) {
      case 'feedback':
      case 'sessions':
      case 'topics-feedback':
        filterToSend.status = { inq: filter.status.map((status: any) => status?.id) };
        break;
      case 'issues':
      case 'validations':
      case 'time-insights':
        filterToSend['insight.status'] = { inq: filter.status.map((status: any) => status?.id) };
        break;
      case 'topics-issues':
        filterToSend.issues_status = { inq: filter.status.map((status: any) => status?.id) };
        break;
      case 'topics-validations':
        filterToSend.values_status = { inq: filter.status.map((status: any) => status?.id) };
        break;
      default:
        filterToSend.status = filter.status;
        break;
    }
  }
  if (filter.integration?.filter((integration: any) => integration?.id !== undefined).length > 0) {
    const integrations = filter.integration.filter(
      (integration: any) => integration?.id !== undefined
    );
    switch (type) {
      case 'insights':
      case 'request':
        filterToSend['insights.integration'] = {
          inq: integrations.map((integration: any) => integration?.id),
        };
        break;
      case 'time-insights':
      case 'issues':
      case 'validations':
        filterToSend['insight.integration'] = {
          inq: integrations.map((integration: any) => integration?.id),
        };
        break;
      case 'metrics':
      case 'topics-issues':
      case 'topics-validations':
      case 'topics-analytics':
      case 'topics-feedback':
      case 'topics-metrics':
        filterToSend.integration = {
          inq: integrations.map((integration: any) => integration?.id),
        };
        break;
      default:
        filterToSend.integrationId = {
          inq: integrations.map((integration: any) => integration?.id),
        };
    }
  }
  if (filter.identity?.length > 0) {
    switch (type) {
      case 'insights':
      case 'request':
        filterToSend['insights.identity'] = { inq: filter.identity };
        break;
      default:
        filterToSend.identity = { inq: filter.identity };
    }
  }
  if (filter.productId?.length > 0) {
    switch (type) {
      case 'issues':
      case 'validations':
      case 'time-insights':
        filterToSend['insight.product'] =
          { inq: filter.productId.map((product: any) => product?.id) } || filter.productId;
        break;
      case 'insights':
      case 'request':
      case 'topics-issues':
      case 'topics-validations':
      case 'topics-feedback':
      case 'topics-metrics':
        filterToSend.product =
          { inq: filter.productId.map((product: any) => product?.id) } || filter.productId;
        break;
      case 'metrics':
        break;
      default:
        filterToSend.productId =
          { inq: filter.productId.map((product: any) => product?.id) } || filter.productId;
        break;
    }
  }
  if (filter.category?.filter((category: any) => category?.id !== undefined)?.length > 0) {
    switch (type) {
      case 'request':
        filterToSend['requestMessages.category'] = {
          inq:
            filter.category
              .filter((category: any) => category?.id !== undefined)
              .map((category: any) => category?.id) || filter.category,
        };
        break;
      case 'insights':
        filterToSend['insights.category'] = {
          inq:
            filter.category
              .filter((category: any) => category?.id !== undefined)
              .map((category: any) => category?.id) || filter.category,
        };
        break;
      case 'time-insights':
        filterToSend['insight.category'] = {
          inq:
            filter.category
              .filter((category: any) => category?.id !== undefined)
              .map((category: any) => category?.id) || filter.category,
        };
        break;
      default:
        filterToSend.category = {
          inq:
            filter.category.map((category: any) => category?.id?.trim()) ||
            filter.category.map((category: any) => category?.trim()),
        };
        break;
    }
  }

  if (filter.metrics?.filter((metric: any) => metric !== null).length > 0) {
    const parseMetrics = (m: any) =>
      m.map((metric: any) => ({
        metricsName: metric.metrics_name,
        metricsValues: metric.metrics_values,
      }));

    switch (type) {
      case 'feedback':
        break;
      case 'issues':
      case 'validations':
        filterToSend.metrics = filter.metrics;
        break;
      case 'request':
      case 'insights':
        filterToSend.metrics = parseMetrics(filter.metrics);
        break;
      case 'metrics':
        break;
      case 'time-insights':
        // filterToSend['insight.metrics.values'] = parseMetrics(filter.metrics);
        break;
      default:
        filterToSend['insights.metrics.values'] = parseMetrics(filter.metrics);
    }
  }

  if (filter.feedback?.length > 0) {
    switch (type) {
      case 'issues':
      case 'validations':
        filterToSend.id = { inq: filter.feedback.map((feedback: any) => feedback?.id) };
        break;
      case 'metrics':
        filterToSend['insight.id'] = { inq: filter.feedback.map((feedback: any) => feedback?.id) };
        break;
      case 'request':
      case 'insights':
        filterToSend['insights.feedbackId'] = {
          inq: filter.feedback.map((feedback: any) => feedback?.id),
        };
        break;

      case 'time-insights':
        filterToSend['insight.feedbackId'] = {
          inq: filter.feedback.map((feedback: any) => feedback?.id),
        };
        break;
      default:
        filterToSend['insight.name'] = {
          inq: filter.feedback.map((feedback: any) => feedback?.id),
        };
    }
  }
  if (filter.integrationId) {
    filterToSend.integrationId = filter.integrationId;
  }
  if (filter.type?.length > 0) {
    filterToSend.type = filter.type;
  }
  if (filter.startDate && filter.endDate) {
    switch (type) {
      case 'insights':
      case 'request':
        filterToSend['insights.externalGeneratedAt'] = {
          between: [parseDate(filter.startDate), parseDate(filter.endDate, true)],
        };
        break;
      case 'feedback':
      case 'topics-issues':
      case 'topics-validations':
      case 'topics-feedback':
      case 'topics-metrics':
        filterToSend.externalGeneratedAt = {
          between: [parseDate(filter.startDate), parseDate(filter.endDate, true)],
        };
        break;
      case 'metrics':
        /* filterToSend['insight.externalGeneratedAt'] = {
          between: [
            filter.startDate.toISOString().slice(0, -1),
            filter.endDate.toISOString().slice(0, -1),
          ],
        }; */
        break;
      case 'topics-analytics':
        filterToSend.day = {
          between: [
            `${parseDate(filter.startDate).slice(0, 10)}`,
            `${parseDate(filter.endDate).slice(0, 10)}`,
          ],
        };
        break;
      default:
        filterToSend['insight.externalGeneratedAt'] = {
          between: [parseDate(filter.startDate), parseDate(filter.endDate, true)],
        };
        break;
    }
  } else if (filter.startDate) {
    switch (type) {
      case 'insights':
      case 'request':
        filterToSend['insights.externalGeneratedAt'] = {
          gt: parseDate(filter.startDate),
        };
        break;
      case 'time-insights':
        filterToSend['insight.externalGeneratedAt'] = {
          gt: parseDate(filter.startDate),
        };
        break;
      case 'metrics':
        /* filterToSend['insight.externalGeneratedAt'] = {
          gt: filter.startDate.toISOString().slice(0, -1),
        }; */
        break;
      case 'topics-analytics':
      case 'topics-metrics':
        filterToSend.day = {
          gt: parseDate(filter.startDate).slice(0, 10),
        };

        break;
      default:
        filterToSend.externalGeneratedAt = {
          gt: parseDate(filter.startDate),
        };
        break;
    }
  } else if (filter.endDate) {
    switch (type) {
      case 'insights':
      case 'request':
        filterToSend['insights.externalGeneratedAt'] = {
          gt: parseDate(filter.endDate, true),
        };
        break;

      case 'time-insights':
        filterToSend['insight.externalGeneratedAt'] = {
          gt: parseDate(filter.endDate, true),
        };
        break;
      case 'metrics':
        /* filterToSend['insight.externalGeneratedAt'] = {
          lt: filter.endDate.toISOString().slice(0, -1),
        }; */
        break;
      case 'topics-analytics':
      case 'topics-metrics':
        filterToSend.day = {
          lt: parseDate(filter.endDate).slice(0, 10),
        };
        break;
      default:
        filterToSend.externalGeneratedAt = {
          lt: parseDate(filter.endDate, true),
        };
        break;
    }
  }
  if (filter['user.email']) {
    filterToSend['user.email'] = filter['user.email'];
  }
  if (filter['user.id']) {
    filterToSend['user.id'] = filter['user.id'];
  }
  if (filter.phase?.length > 0) {
    filterToSend.phase = { inq: filter.phase };
  }
  if (filter.userId) {
    filterToSend.userId = filter.userId;
  }

  if (filter.completed) {
    switch (type) {
      case 'insights':
      case 'request':
        filterToSend['insights.finished'] = filter.completed;
        break;
      case 'time-insights':
        // filterToSend['insight.finished'] = filter.completed;
        break;

      case 'issues':
      case 'validations':
        // filterToSend['insight.completed'] = filter.completed;
        break;
      default:
        filterToSend.finished = filter.completed;
    }
  }

  if (filter.quality?.length > 0) {
    switch (type) {
      case 'issues':
      case 'validations':
      case 'time-insights':
        filterToSend['insight.quality'] = { inq: filter.quality };
        break;
      case 'insights':
      case 'request':
        filterToSend['insights.quality'] = { inq: filter.quality };
        break;
      default:
        filterToSend.quality = { inq: filter.quality };
    }
  }

  if (filter.and) {
    filterToSend.and = filter.and;
  }
  if (filter.or) {
    filterToSend.or = filter.or;
  }

  if (filter.issues) {
    const { min, max } = filter.issues;
    let value;
    if (min && max) {
      value = {
        between: [min, max],
      };
    } else if (min) {
      value = {
        gt: min,
      };
    } else if (max) {
      value = {
        lt: max,
      };
    }

    switch (type) {
      case 'insights':
      case 'request':
        filterToSend['insights.issues'] = value;
        break;
      case 'feedback':
        filterToSend.issues = value;
        break;
      case 'issues':
      case 'validations':
      case 'time-insights':
        break;
      default:
        filterToSend['insight.issues'] = value;
    }
  }

  if (filter.values) {
    const { min, max } = filter.values;
    let value;
    if (min && max) {
      value = {
        between: [min, max],
      };
    } else if (min) {
      value = {
        gt: min,
      };
    } else if (max) {
      value = {
        lt: max,
      };
    }
    switch (type) {
      case 'insights':
      case 'request':
        filterToSend['insights.values'] = value;
        break;
      case 'time-insights':
      case 'issues':
      case 'validations':
        break;
      case 'feedback':
        filterToSend.values = value;
        break;
      default:
        filterToSend['insight.values'] = value;
    }
  }

  if (filter.topics?.length > 0) {
    switch (type) {
      case 'topics-feedback':
        filterToSend.topics = { inq: filter.topics };
        break;
      case 'topics-issues':
        filterToSend.issues_topics = { inq: filter.topics };
        break;
      case 'topics-validations':
        filterToSend.values_topics = { inq: filter.topics };
        break;
      default:
        filterToSend.topics = { inq: filter.topics };
        break;
    }
  }

  return filterToSend;
};
